import type { UserRole } from "../types/domain";

/**
 * Platform UI / routes: allowed when the signed-in user's row in `public.users` has
 * `role === 'super_admin'`. That role is the app source of truth — not tenant_id,
 * not session e-mail, and do not reintroduce hardcoded e-mail allowlists here or in Edge Functions.
 */
export function canAccessPlatformAdmin(role: UserRole | null): boolean {
  return role === "super_admin";
}

/**
 * g4-c7 — de supportrol. Bewust GEEN onderdeel van `canAccessPlatformAdmin`:
 * support is geen platformbeheer. Deze rol heeft precies één scherm, en wat
 * daar te zien is hangt af van een lopende grant — niet van deze functie.
 */
export function isPlatformSupportRole(role: UserRole | null): boolean {
  return role === "platform_support";
}
